'use client'

import { StarIcon } from '@heroicons/react/20/solid'

function classNames(...classes) {
    return classes.filter(Boolean).join(' ')
}

export default function ReviewList({ reviews }) {
    const averageRating = reviews.length > 0
        ? reviews.reduce((acc, review) => acc + review.rating, 0) / reviews.length
        : 0

    return (
        <div className="mt-16">
            <h2 className="text-lg font-medium text-gray-900">Customer Reviews</h2>
            <div className="mt-6">
                {reviews.length === 0 && <p className="text-sm text-gray-600">No reviews yet. Be the first to review this product.</p>}
                <div className="flex items-center">
                    <p className="text-sm text-gray-700">
                        {averageRating.toFixed(1)}
                        <span className="sr-only"> out of 5 stars</span>
                    </p>
                    <div className="ml-1 flex items-center">
                        {[0, 1, 2, 3, 4].map((rating) => (
                            <StarIcon
                                key={rating}
                                aria-hidden="true"
                                className={classNames(
                                    averageRating > rating ? 'text-yellow-400' : 'text-gray-200',
                                    'h-5 w-5 shrink-0',
                                )}
                            />
                        ))}
                    </div>
                    <div aria-hidden="true" className="ml-4 text-sm text-gray-300">·</div>
                    <div className="ml-4 flex">
                        <p className="text-sm font-medium text-gray-700">
                            Based on {reviews.length} reviews
                        </p>
                    </div>
                </div>

                <div className="mt-10 space-y-10">
                    {reviews.map((review) => (
                        <div key={review.id} className="flex flex-col sm:flex-row">
                            <div className="mt-6 sm:mt-0 sm:ml-4">
                                <div className="flex items-center">
                                    <p className="text-sm font-medium text-gray-900">{review.user.name}</p>
                                    {review.verified_purchase && <span className="ml-2 text-xs font-semibold text-green-700">Verified purchase</span>}
                                    <div className="ml-2 flex items-center">
                                        {[0, 1, 2, 3, 4].map((rating) => (
                                            <StarIcon
                                                key={rating}
                                                className={classNames(
                                                    review.rating > rating ? 'text-yellow-400' : 'text-gray-200',
                                                    'h-5 w-5 shrink-0'
                                                )}
                                                aria-hidden="true"
                                            />
                                        ))}
                                    </div>
                                </div>
                                <p className="mt-2 text-sm text-gray-600">{review.comment}</p>
                                <p className="mt-2 text-xs text-gray-500">
                                    {new Date(review.created_at).toLocaleDateString()}
                                </p>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    )
}
